import { Box } from '@zillow/constellation-10';
import { IconCatOutline, IconDogLargeOutline, IconNoPetsOutline, IconPetsOutline } from '@zillow/constellation-icons';
import { StatCard } from './StatCard';
import type { PercentageDatum } from '../RenterDataReport.utils';

const getPetIcon = (label: string) => {
  const lowerLabel = label.toLowerCase();
  if (lowerLabel.includes('cat')) return <IconCatOutline />;
  if (lowerLabel.includes('dog') || lowerLabel.includes('large')) return <IconDogLargeOutline />;
  if (lowerLabel.includes('no pet')) return <IconNoPetsOutline />;
  return <IconPetsOutline />;
};

type StatCardGridProps = {
  data: Array<PercentageDatum>;
  showIcons?: boolean;
};

export const StatCardGrid = ({ data, showIcons = false }: StatCardGridProps) => {
  return (
    <Box
      css={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(100px, 1fr))',
        gap: '400',
      }}
    >
      {data.map((item) => (
        <StatCard
          key={item.label}
          label={item.label}
          value={item.value}
          icon={showIcons ? getPetIcon(item.label) : undefined}
        />
      ))}
    </Box>
  );
};
